export type WhatsappBspOverviewMessages = {
  whatsappBspOverviewText1: string;
  whatsappBspOverviewText2: string;
  whatsappBspOverviewText3: string;
  whatsappBspOverviewArticleLinkText: string;
  whatsappBspOverviewArticleLinkSource: string;
};

export const whatsappBspOverviewMessages: WhatsappBspOverviewMessages = {
  whatsappBspOverviewText1:
    "Conecte sua conta WhatsApp Business e transforme o WhatsApp numa verdadeira plataforma de vendas on-line.",
  whatsappBspOverviewText2: "Deseja saber mais sobre o processo de conexão de sua conta?",
  whatsappBspOverviewText3: "Acesse a documentação: ",
  whatsappBspOverviewArticleLinkText: "Conexão com o WhatsApp",
  whatsappBspOverviewArticleLinkSource:
    "https://talk2buy.tomticket.com/kb/plataforma/t2b-pop-configuracao-plataformas-whatsapp",
};

